// extracted by mini-css-extract-plugin
module.exports = {"root":"MileRankButton_root__5MZYu","title":"MileRankButton_title__BCuDn","icon":"MileRankButton_icon__Trcux"};